<template>
  <div id="app" style="height: 100%; width: 100%;">
    <!-- Timer -->
    <!-- <span class="w3-text-amber w3-xxlarge" style="position: fixed; z-index: 50; right: 10%; bottom: 10%;">{{ millisToMinutesAndSeconds(quizzRemainingTime) }}</span> -->

    
    <!-- Back button -->
    
    <!-- <button class="w3-xlarge" style="position: absolute; left: 50px; top: 50px; z-index: 10; text-align: center; background: none; border: none; font-family: 'Bebas'; color: #8b817f;"> <a href="index.html" style="text-decoration: none;"><span style="font-size: xx-large;"> &larr; </span> {{ (language == "fr")?"Retour à l'accueil":"Back to home" }}</a> </button> -->
    
    <!-- <p class="w3-text-white" style="position: absolute; left: 880px; top: -220px; z-index: 10; font-size: 200px; text-align: center; font-family: 'Bebas';"> 03 </p> -->
    
    <!-- No Quiz found -->
    <div v-if="quizData == null">
        <div class="w3-center w3-xxxlarge">404</div>
        <div class="w3-center w3-xxlarge">Le quizz demandé n'existe pas. </div>
    </div>

    <!-- End page -->
    <div v-else-if="quizData.endPage" class="w3-container w3-center" style="height: 100%;">
        <div class="w3-center w3-xlarge">Félicitations !</div>
        <div class="w3-center w3-xxlarge w3-padding">Vous avez terminé le quizz !</div>
        <img class="w3-image w3-animate-zoom" v-bind:src="getPic('bravo.svg')" width="60%">


    </div>
    
    <!-- Quizz page -->
    <div v-else>
        <div class="w3-cell-row">
            <div class="w3-container">
                <p class="question-title">{{ quizData.questions[quizData.currentQuestionId].language[quizData.language].title }} </p>
            </div>
        </div>
        <div class="w3-cell-row">

            <div class="w3-container w3-center w3-cell w3-cell-middle w3-mobile">    
                <div v-for="(question, index) in quizData.questions" v-bind:key="index">
                    <div v-if="question.id == quizData.currentQuestionId">
                        <!-- <p class="w3-xxxlarge" style="text-align: left; margin-left: 15%; font-family: 'Bebas';"> Question  / {{ numberOfQuestion }} </p> -->
                        <!-- <p class="w3-xxlarge w3-text-white w3-large" style="text-align: left; margin-left: 15%; margin-top: -50px;"> {{ (language == "fr")?'Sélectionnez une réponse parmi ces propositions.':'Select one of these answers.' }} </p> -->
                        <Question v-on:select-answer="selectAnswer" v-on:change-question="changeQuestion" v-on:end="end" v-bind:question-model="question" />
                    </div>
                </div>
            </div>
        </div>
        <div class="w3-white w3-cell-row" style="height: 35px;">
        </div>
        <div class="w3-cell-row">
            <div v-for="(question, index) in quizData.questions" v-bind:key="index">
                <div v-if="question.id == quizData.currentQuestionId">
                    <!-- <p class="w3-xxxlarge" style="text-align: left; margin-left: 15%; font-family: 'Bebas';"> Question  / {{ numberOfQuestion }} </p> -->
                    <!-- <p class="w3-xxlarge w3-text-white w3-large" style="text-align: left; margin-left: 15%; margin-top: -50px;"> {{ (language == "fr")?'Sélectionnez une réponse parmi ces propositions.':'Select one of these answers.' }} </p> -->
                    <Greeting  v-bind:question-model="question" />
                </div>
            </div>
        </div>
    </div>
    <!-- Language selection -->
    <!-- <LanguageSelector v-on:language-change="changeLanguage"/> -->
  </div>
</template>

<script>
import quizzes from './data/quizzes/quizzes.json'

import Question from './components/Question.vue'
import Greeting from './components/Greeting.vue'

const quizzInitialRemainingTime = 3000

function getQuizNameFromUrl()
{
    var queryString = location.search;
    
    let params = new URLSearchParams(queryString);
    return params.get("q");

}

function getQuizLocaleFromUrl()
{
  var queryString = location.search;

  let params = new URLSearchParams(queryString);
  return params.get("locale");

}

function loadQuizCss(quiz)
{
    if (quiz.customStyle != null && quiz.customStyle != "") {
        import(`${quiz.customStyle}`);
    }
}

// request for quiz 
function loadQuizData(path)
{
    if (quizzes[path] != null) loadQuizCss(quizzes[path]);
    return quizzes[path]; 
}

export default {
  name: 'App',
  components: {
    Question,
    Greeting
  },
  data: function() {
      return {
          quizData: loadQuizData(getQuizNameFromUrl())
      }
  },
  computed: {
      numberOfQuestion(){
          return this.quizData.questions.length
      }
  },
  mounted() {
    let locale = getQuizLocaleFromUrl();
    if (locale) {
      this.changeLanguage(locale);
    }
    if (localStorage.language) {
        this.quizData.language = localStorage.language;
    }
  },
  methods: {
      selectAnswer(event, answerId) {
          if(this.quizData.questions[this.quizData.currentQuestionId].answered === false){
              if(this.quizData.quizzRemainingTime == quizzInitialRemainingTime){
                  this.startQuizzTimer();
              }
              this.quizData.selectedAnswerId = answerId;
              this.checkAnswer();
          }
      },

      checkAnswer() {
          let newQuestionDatas = this.quizData.questions[this.quizData.currentQuestionId];
          if(newQuestionDatas.answerIds.indexOf(this.quizData.selectedAnswerId) != -1){
              newQuestionDatas.correct = true;
          }
          newQuestionDatas.answered = true;
          this.$set(this.quizData.questions, this.quizData.currentQuestionId, newQuestionDatas);
      },

      changeQuestion(event, nextQuestionId) {
          if(nextQuestionId < this.quizData.questions.length && nextQuestionId > -1){
              this.quizData.currentQuestionId = nextQuestionId;
          }
      },

      end() {
          this.quizData.endPage = true;
          setTimeout(() => {
              document.location.reload(true);
          }, this.quizData.autoReloadTimeout);
      },

      getPic(name) {
          return './images/' + name;
      },

      millisToMinutesAndSeconds(millis) {
          let minutes = Math.floor(millis / 60000);
          let seconds = ((millis % 60000) / 1000).toFixed(0);
          return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
      },

      startQuizzTimer() {
          this.quizData.quizzTimer = setTimeout(() => {
              this.quizData.quizzRemainingTime = this.quizData.quizzRemainingTime - 1000;
              if(this.quizData.quizzRemainingTime > 0){
                  this.startQuizzTimer(); 
              }
          }, 1000); 
      },
      
      getCorrectTotal() {
          let total = 0;
          this.quizData.questions.forEach(question => {
              if (question.correct) {
                  total = total + 1;
              }
          });
          return total;
      },

      changeLanguage(language) {
          this.quizData.language = language;
          localStorage.language = language;
      }
  }
}
</script>
